import Holding from "./Holding";
import Portfolio from "./Portfolio";

export default class SummaryHolding extends Holding {
    private _payout:number = 0
    private _yield:number = 0
    constructor(portfolio:Portfolio, id:string, holdings:Holding[]) {
        super(portfolio, id, [])

        let totalValue = 0, holdingDiv = 0;
        for(const holding of holdings){
            this.quantity += holding.quantity
            this.holdingCost += holding.holdingCost
            this._payout += holding.payout
            this.n_payout += holding.n_payout
            this.a_payout += holding.a_payout
            this.ytd_payout += holding.ytd_payout
            this.dividend += holding.dividend
            this.profit += holding.profit
            this.gain += holding.gain
            this.originalCost += holding.originalCost
            if (holding.quantity>0) holdingDiv += holding.dividend
            totalValue += holding.transactions.reduce((p,t) => p + (t.isBuy ? t.quantity : 0), 0)
            this.transactions.push(...holding.transactions)
        }
        if (this.quantity) this._yield = this.payout/this.quantity*100
        this.holdingValue = this.quantity
        this.currency = this.price.currency
        this.mwPercent = this.gain/this.originalCost*100
        this.currentPrice = 1;
        this.averagePrice = this.originalCost/totalValue
        this.holdingPercent = this.holdingValue ? holdingDiv / this.holdingValue : 0
    }
    computePerformance(): this {
        return this
    }
    computePayout(): this {
        return this
    }
    get payout() { return this.a_payout}
    get yield() { return this._yield}
}